<script setup lang="ts">
import type { AlertProps } from "./alert.types";
import { useAlert } from "./useAlert";

defineOptions({ name: "EAlert" });

const props = withDefaults(defineProps<AlertProps>(), {
  color: "neutral",
  variant: "subtle",
});

const { hasIcon, classes, cardCls } = useAlert(props);
</script>

<template>
  <e-primitive class="e-alert" :inner-class="cardCls">
    <div class="e-alert-grid" :class="classes.grid" part="grid">
      <e-icon v-if="hasIcon" :name="icon" size="sm" part="icon" class="e-alert-icon col-start-1 row-start-1" />
      <div class="e-alert-header" part="header" :class="classes.header">
        <slot name="header">{{ title }}</slot>
      </div>
      <div class="e-alert-body" part="body" :class="classes.body">
        <slot />
      </div>
      <div class="e-alert-actions" part="actions" :class="classes.actions">
        <slot name="actions" />
      </div>
    </div>
  </e-primitive>
</template>

<style>
:host {
  display: contents;
}
</style>
